const noop = () => {};

const storageMock = {
  removeItem: noop,
  setItem: noop,
  getItem: noop
};
const storage = 'sessionStorage' in globalThis ? globalThis.sessionStorage : storageMock;
export const sessionStorage = {
  set(key, values) {
    storage.setItem(key, JSON.stringify(values));
  },

  get(key) {
    const values = storage.getItem(key);
    return values ? JSON.parse(values) : values;
  },

  remove(key) {
    storage.removeItem(key);
  }

};